export const FileHandlerService = {
  Load: (path : string, load: (contents: any) => void) => {
    fetch(path)
      .then((r) => r.text())
      .then((text) => load(JSON.parse(text)));
  },

  LoadSync: async (path : string) => {
    const response = await fetch(path);
    const json = await response.json();
    return json;
  },
};
